import React from "react";

/**
 * Contact icons for the portfolio hero. Inline SVG (no icon dependency), sized
 * by the caller through className.
 */
const base = "h-4 w-4 shrink-0";

export const MailIcon = () => (
  <svg className={base} viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M2 5.5A2.5 2.5 0 0 1 4.5 3h15A2.5 2.5 0 0 1 22 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 18.5v-13Zm2.6-.5 7.4 5.55L19.4 5H4.6Zm15.4 1.7-7.4 5.55a1 1 0 0 1-1.2 0L4 6.7v11.8c0 .28.22.5.5.5h15a.5.5 0 0 0 .5-.5V6.7Z"
    />
  </svg>
);

export const GithubIcon = () => (
  <svg className={base} viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 .5C5.73.5.75 5.48.75 11.75c0 4.96 3.22 9.17 7.69 10.66.56.1.77-.24.77-.54v-1.9c-3.13.68-3.79-1.34-3.79-1.34-.51-1.3-1.25-1.65-1.25-1.65-1.02-.7.08-.69.08-.69 1.13.08 1.72 1.16 1.72 1.16 1 1.72 2.63 1.22 3.27.93.1-.73.39-1.22.71-1.5-2.5-.29-5.13-1.25-5.13-5.56 0-1.23.44-2.24 1.16-3.03-.12-.29-.5-1.44.11-3 0 0 .95-.3 3.11 1.16a10.8 10.8 0 0 1 5.66 0c2.16-1.46 3.11-1.16 3.11-1.16.61 1.56.23 2.71.11 3a4.4 4.4 0 0 1 1.16 3.03c0 4.32-2.63 5.27-5.14 5.55.4.35.76 1.03.76 2.08v3.08c0 .3.21.65.78.54a11.25 11.25 0 0 0 7.68-10.66C23.25 5.48 18.27.5 12 .5Z"
    />
  </svg>
);

export const LinkedinIcon = () => (
  <svg className={base} viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.36V9h3.41v1.56h.05a3.74 3.74 0 0 1 3.37-1.85c3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13ZM7.12 20.45H3.56V9h3.56v11.45ZM22.23 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.72V1.72C24 .77 23.21 0 22.23 0Z"
    />
  </svg>
);

export const GlobeIcon = () => (
  <svg className={base} viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm6.93 6h-2.95a15.6 15.6 0 0 0-1.4-3.6A8.03 8.03 0 0 1 18.93 8ZM12 4.04c.64.93 1.16 2.06 1.5 3.96h-3c.34-1.9.86-3.03 1.5-3.96ZM4.26 14a7.96 7.96 0 0 1 0-4h3.38a16.6 16.6 0 0 0 0 4H4.26Zm.81 2h2.95c.33 1.3.8 2.52 1.4 3.6A8.03 8.03 0 0 1 5.07 16Zm2.95-8H5.07a8.03 8.03 0 0 1 4.35-3.6A15.6 15.6 0 0 0 8.02 8ZM12 19.96c-.64-.93-1.16-2.06-1.5-3.96h3c-.34 1.9-.86 3.03-1.5 3.96ZM14.34 14H9.66a14.9 14.9 0 0 1 0-4h4.68a14.9 14.9 0 0 1 0 4Zm.24 5.6c.6-1.08 1.07-2.3 1.4-3.6h2.95a8.03 8.03 0 0 1-4.35 3.6ZM16.36 14a16.6 16.6 0 0 0 0-4h3.38a7.96 7.96 0 0 1 0 4h-3.38Z"
    />
  </svg>
);

/* Codeforces mark: three bars of increasing height. */
export const CodeforcesIcon = () => (
  <svg className={base} viewBox="0 0 24 24" aria-hidden="true">
    <rect x="1" y="10" width="6" height="11" rx="1.5" fill="currentColor" />
    <rect x="9" y="5" width="6" height="16" rx="1.5" fill="currentColor" />
    <rect x="17" y="13" width="6" height="8" rx="1.5" fill="currentColor" />
  </svg>
);

export const ScholarIcon = () => (
  <svg className={base} viewBox="0 0 24 24" aria-hidden="true">
    <path fill="currentColor" d="M12 2 0 8.5l12 6.5 9.8-5.31V17H24V8.5L12 2Z" />
    <path
      fill="currentColor"
      d="M5 12.53v3.3c0 1.9 3.13 3.67 7 3.67s7-1.77 7-3.67v-3.3l-7 3.8-7-3.8Z"
    />
  </svg>
);

export const PinIcon = () => (
  <svg className={base} viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5Z"
    />
  </svg>
);
